import {Component} from 'react';
import h from 'react-hyperscript';
import './MobileNav.scss';
import NavbarUpper from 'Components/Header/NavbarUpper/NavbarUpper';
import Drawer from '@material-ui/core/Drawer';
import MobileNavLoggedIn from './MobileNavLoggedIn';
import {BREAKPOINT_MOBILE} from '../../../utils/gtm/const';

class MobileNav extends Component {
  render() {
    return (
      h(Drawer, {
        id: 'mobile-nav__drawer',
        key: 'mobile-nav__drawer',
        open: this.props.mobileLogin &&
        window.innerWidth <= BREAKPOINT_MOBILE ? !this.props.open :
        this.props.open,
        onClose: this.props.onClose,
      }, [

        h('div', {
          id: 'mobile-nav__content',
          key: 'mobile-nav__content',
          className: 'mobile-nav__container',
          tabIndex: 0,
          role: 'button',
          onClick: this.props.onClose,
          onKeyDown: this.props.onClose,
        }, [

          h(NavbarUpper, {
            id: 'header__nav-upper--mobile',
            key: 'header__nav-upper--mobile',
            className: 'header__upper--mobile',
          }, null),

          h('div', {
            id: 'mobile-nav__lower',
            key: 'mobile-nav__lower',
            className: 'header__lower--mobile header__lower',
          }, [
            h('span', {
              id: 'header__product-name--mobile',
              key: 'header__product-name--mobile',
              className: 'padding-right--sm text--grey',
            }, this.props.siteTitle),
          ]),

          h(MobileNavLoggedIn, {
            needsDistrictConfig: this.props.needsDistrictConfig,
            handleMenuClose: this.props.onClose,
            handleSettingsOpen: this.props.handleSettingsOpen,
            googleUser: this.props.googleUser,
            userStatus: this.props.userStatus,
            logoutClick: this.props.logoutClick,
            loginClick: this.props.loginClick,
            isAdmin: this.props.isAdmin,
          }, null),
        ]),
      ])
    );
  }
}
export default MobileNav;
